
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ShuffleMaps/Locations",
      function () {
        return require("private-next-pages/ShuffleMaps/Locations.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ShuffleMaps/Locations"])
      });
    }
  